import script from "./HeroLacen.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroLacen.vue?vue&type=script&setup=true&lang=js"

import "./HeroLacen.vue?vue&type=style&index=0&id=566e9b22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566e9b22"]])

export default __exports__